
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, NgZone, HostListener, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { UserService } from '../_services/user.service';
import * as firebase from 'firebase';
import { Subscription } from 'rxjs';
import { SaveMessageComponent } from '../directive/save-message/save-message.component';
import { MatDialog } from '@angular/material';
import { PhoneTakeRequestComponent } from '../directive/phone-take-request/phone-take-request.component';
import { ScrollService } from '../_services/scroll.service';
import { CategoriesService } from '../_services/categories.service';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';
this.storagePath = environment.storagePath;

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})

export class NavBarComponent implements OnInit {
  user: any;
  visible: boolean;
  isNavbarCollapsed;
  ipAddress: any;
  categories = [];
  isLoading = true;
  url: any;

  private subscription: Subscription = new Subscription();
  userId = this.userService.getUid();


  constructor(
    private modalService: NgbModal,
    private afs: AngularFirestore,
    private router: Router,
    private dialog: MatDialog,
    private _http: Http,
    private zone: NgZone,
    private userService: UserService,
    private scrollservice: ScrollService,
    private categoriesService: CategoriesService) {
    this.isNavbarCollapsed = true;



    this.subscription.add(this.userService.getUser().subscribe(user => {
      if (user) {
        this.user = user;

      }

    }));
    this.getIpAdress();



    this.subscription = this.scrollservice.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 0) {
        this.visible = true;
      }
      else {
        this.visible = false;
      }
    })
    this.userService.setUser(localStorage.getItem('currentUserId'));
    this.categoriesService.categories.forEach(data => {
      this.categories.push(data);
    });
  }






  ngOnInit() {
    this.url = decodeURIComponent(this.router.url);
    console.log(this.url);



  }
  navigate(name) {
    this.zone.run(() => this.router.navigate(['/category/' + name]))
  }



  scrollTop() {
    window.scrollTo(0, 0);
  }

  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }

  logout() {

    this.afs.collection('logs').add({
      userId: this.user.id,
      date: new Date(),
      type: 'logout',
      ipAddress: this.ipAddress,
      url: 'bigadvice.com'
    }).then(() => {
      firebase.auth().signOut().then(() => { this.userService.clearUser() }).then(() => {
        this.router.navigate(["/"]);
      });
    });

  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  open(content, ctrl) {


    if (this.userId) {
      this.afs.collection('posts').ref.where('user', '==', this.userId).get().then(data => {
        const x = [];

        data.forEach(post => {
          if (post.data().modifyDate > Date.now() - 86400000) {
            x.push(post.data());
          }
        });

        if (x.length >= 10 && ctrl === 0) {
          this.dialog.open(SaveMessageComponent, {
            width: '600px',
            data: {
              message: 'Günlük paylaşım hakkını doldurdun, ama biz seni dinlemeye doyamadık! Yarın yeni paylaşımların için bekliyoruz :)',
              type: "update"
            }
          });

        }
        else {

          this.modalService.open(content, { backdrop: "static" });
        }
      });


    }
    else {
      this.router.navigate(["/auth"]);
    }

  }


  requestPhone(content, ctrl) {
    if (this.userId) {
      this.dialog.open(PhoneTakeRequestComponent, {
        width: 'auto',
        height: '80%',
        data: {
          title: 'Tebrikler!',
          type: "badge",
          image: "categoryIcons/" + "category.uniqueName" + ".png",
          content: "category.name" + ' kategorisinde uzmanlık kazandın.'
        }
      });
    }
    else {
      this.modalService.open(content, { backdrop: "static" });
    }
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/nav-bar/nav-bar.component.ts